import { createElementBlock as t, openBlock as l, createStaticVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
};
function a(i, e) {
  return l(), t("svg", r, [...e[0] || (e[0] = [
    o('<g clip-path="url(#a)"><path fill="url(#b)" fill-rule="evenodd" d="M2.897 20.759c0 2.4 1.945 4.344 4.344 4.344H20.76c2.4 0 4.344-1.945 4.344-4.344V7.24c0-2.4-1.945-4.344-4.344-4.344H7.24A4.345 4.345 0 0 0 2.897 7.24zM7.24 28C3.242 28 0 24.758 0 20.759V7.24C0 3.242 3.242 0 7.241 0H20.76C24.758 0 28 3.242 28 7.241V20.76C28 24.758 24.758 28 20.759 28zM5.793 14c0-.384.153-.752.424-1.024l3.862-3.862a1.448 1.448 0 1 1 2.048 2.048l-1.39 1.39h6.525l-1.39-1.39a1.448 1.448 0 0 1 2.049-2.048l3.862 3.862a1.45 1.45 0 0 1 0 2.048l-3.862 3.862a1.448 1.448 0 1 1-2.048-2.048l1.39-1.39h-6.525l1.39 1.39a1.448 1.448 0 1 1-2.049 2.048l-3.862-3.862A1.45 1.45 0 0 1 5.793 14" clip-rule="evenodd"></path></g><defs><linearGradient id="b" x1="2.5" x2="26" y1="2" y2="25.5" gradientUnits="userSpaceOnUse"><stop stop-color="#05CA79"></stop><stop offset="1" stop-color="#006043"></stop></linearGradient><clipPath id="a"><rect width="28" height="28" fill="#fff" rx="2"></rect></clipPath></defs>', 2)
  ])]);
}
const c = { render: a };
export {
  c as default,
  a as render
};
